/* istanbul ignore file */
import { parsers } from '@codegrade/utils';
import { ExportAssignmentCSVData } from './ExportAssignmentCSVData';
import { ExportAssignmentFilesData } from './ExportAssignmentFilesData';
const ExportAssignmentDataParser = 
/* #__PURE__ */ /* #__PURE__ */ parsers.taggedUnion('type', [
    ['info', ExportAssignmentCSVData],
    ['files', ExportAssignmentFilesData],
]);
export const ExportAssignmentData = ExportAssignmentDataParser;
